import { MutableRefObject, useEffect, useRef } from 'react';

// tells an awaited call whether the component that made it is still on the page
const useIsMountedRef = (): MutableRefObject<boolean> => {
  const isMountedRef = useRef<boolean>(true);

  useEffect(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  return isMountedRef;
};

export default useIsMountedRef;
